import React from 'react';
import { Rate } from 'antd';
import { CollapsibleNote } from '../../../shared/DetailsCard';

interface Props {
  rate: number;
  comment?: string;
}

const CustomerRating: React.FC<Props> = ({ rate, comment }) => (
  <>
    <Rate value={rate} disabled />
    {comment && <CollapsibleNote value={comment} />}
  </>
);

export default CustomerRating;
